import { useState } from 'react';
import './styles.scss';

const NavigationSideBar = ({ items, offset, activeIndex }) => {
    // TODO: ADD LOGIC SELECTION ACTIVE ITEM ON SCROLL
    // const [active, setActive] = useState('');
    // const onSection = el => {
    //     const clickedTitle = items.find(item => item === el);
    //     setActive(el);
    //     const targetElement = document.getElementById(clickedTitle);
    //     // const targetPosition = targetElement?.offsetTop + 980;
    //     const targetPosition = targetElement?.offsetTop + offset;

    //     window.scrollTo({
    //         top: targetPosition,
    //     });
    // };

    return (
        <div className="navigation-sidebar">
            {items.map((el, index) => (
                <div
                    key={el}
                    className={`navigation-sidebar__item ${index === activeIndex ? 'navigation-sidebar__active' : ''}`}
                    // onClick={() => onSection(el)}
                >
                    <p className="button-text">{el.toUpperCase()}</p>
                </div>
            ))}
        </div>
    );
};

export default NavigationSideBar;
